module.exports = __webpack_public_path__ + "img/menu3.5097adc.png";